import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  card: {
    backgroundColor: "#FAFBFC",
    "& .MuiCardContent-root": {
      [theme.breakpoints.down("sm")]: {
        paddingInline: 0,
        paddingBlock: "2rem",
      },
    },
  },
  cardContainer: () => ({
    backgroundColor: "rgba(56, 160, 218, 0.1)",
    padding: "1.6875em 0.8125em 3em 0.75em",
    whiteSpace: "normal",
    "& .MuiCardContent-root": {
      backgroundColor: "#fafbfc",
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexFlow: "column nowrap",
      justifyContent: "center",
      alignItems: "center",
      alignContent: "center",
    },
  }),
  image: {
    display: "block",
    margin: "2.1875rem auto",
  },
  title: {
    fontFamily: "Lato",
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(18),
    width: "100%",
    whiteSpace: "normal",
    marginBlockEnd: "1.75rem",
    paddingInline: "0.6875em 0.75em",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  list: () => ({
    paddingInline: "0.6875em 0.75em",
    "& svg": {
      position: "relative",
      top: "0.4rem",
    },
    "& li": {
      padding: "unset",
      marginBlockEnd: "1em",
    },
    "& .MuiTypography-root": {
      fontFamily: "Lato",
      fontWeight: 400,
      color: "#000000",
      fontSize: theme.typography.pxToRem(14),
      whiteSpace: "normal",
    },
  }),
  accent: () => ({
    "& .MuiTypography-root": {
      color: "#C14820",
      fontWeight: 800,
    },
  }),
  button: () => ({
    background: "#0236B0",
    "&:hover": {
      backgroundColor: "#0236B0",
    },
    "& .MuiButton-label": {
      fontFamily: "Inter",
      color: "white",
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 600,
      textTransform: "none",
      [theme.breakpoints.down("sm")]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    paddingBlock: "0.5em",
    paddingInline: "1.5em",
    borderRadius: "6.25em",
    "& svg": {
      display: "inline-flex",
      alignSelf: "center",
      top: "0.52rem",
      left: "0.5rem",
      position: "relative",
    },
    "& svg path": {
      fill: "#22D9BB",
    },
  }),
}));
